import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    position: "relative"
  },
  header: {
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
    padding: "16px 20px 20px",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 16,
    [theme.breakpoints.down("sm")]: {
      padding: "24px 20px 20px",
      "&.withoutPadding": {
        padding: 0
      }
    }
  },
  listEntry: {
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    "&:nth-child(2n + 1)": {
      background: "#f6f6f6"
    }
  },
  description: {
    marginTop: 4,
    marginBottom: 20
  }
}));
